export default Object.freeze({
  RESI: 'resi',
  PRO: 'pro'
});



// WEBPACK FOOTER //
// ./src/enums/modules/customerTypeEnum.js